import React from 'react';
import { Typography, Grid, Button } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import useHomePageCategoryListingCardStyles from './HomePageCategoryListingCard.styles';
import MarkdownLink from './MarkdownLink';
import MarkdownImage from './MarkdownImage';

export interface HomePageCategoryListingCardProps {
  description: string;
  imageSrc: string;
  href: string;
  title: string;
  learnMoreLabel?: string;
}

export default function HomePageCategoryListingCard({
  description,
  imageSrc,
  href,
  title,
  learnMoreLabel,
}: HomePageCategoryListingCardProps) {
  const {
    classes: {
      container,
      image,
      description: descriptionStyle,
      link: linkStyle,
      title: titleStyle,
    },
  } = useHomePageCategoryListingCardStyles();
  const { translate } = useTranslation();

  return (
    <DynamicallyRouted.Link href={href}>
      <Grid item XSmall={12} Medium={6} XLarge={3}>
        <Grid className={container} container wrap='nowrap' direction='column'>
          <MarkdownImage className={image} src={imageSrc} />
          <Typography className={titleStyle} variant='h4'>
            {title}
          </Typography>
          <Typography className={descriptionStyle} variant='body2' color='secondary'>
            {description}
          </Typography>
          <MarkdownLink className={linkStyle} href={href}>
            <Button size='small'>{learnMoreLabel ?? translate('Label.LearnMore')}</Button>
          </MarkdownLink>
        </Grid>
      </Grid>
    </DynamicallyRouted.Link>
  );
}
